import { io } from 'socket.io-client';
import { API_ORIGIN } from './api/axiosConfig';

// Если есть явное окружение для сокета — используем его,
// иначе пробуем API_ORIGIN, а если он без субдомена, используем api.<host>.
function resolveSocketBase() {
  const fromEnv = process.env.REACT_APP_SOCKET_ORIGIN?.trim();
  if (fromEnv) return fromEnv.replace(/\/$/, '');

  // Если API_ORIGIN уже указывает на api-сабдомен — используем его
  try {
    const u = new URL(API_ORIGIN || window.location.origin);
    if (u.hostname.startsWith('api.')) return `${u.protocol}//${u.host}`;
    // иначе подставим api. перед основным хостом
    return `${u.protocol}//api.${u.host.replace(/^www\./, '')}`;
  } catch {
    return typeof window !== 'undefined' ? window.location.origin : '';
  }
}

const BASE = resolveSocketBase();
const PATH = process.env.REACT_APP_SOCKET_PATH?.trim() || '/socket.io';

export const socket = io(BASE, {
  path: PATH,
  autoConnect: false,
  transports: ['websocket', 'polling'], // оставим оба транспорта
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  timeout: 15000,
});

// Подключение с токеном из localStorage
export function connectSocketWithToken() {
  try {
    const tok =
      localStorage.getItem('token') ||
      localStorage.getItem('accessToken') ||
      localStorage.getItem('jwt');
    if (tok) socket.auth = { token: tok };
    if (!socket.connected) socket.connect();
  } catch {}
}

export function disconnectSocketSafe() {
  try { if (socket.connected) socket.disconnect(); } catch {}
}

// Логи
socket.on('connect', () => console.log('[socket] connected', socket.id, '→', BASE + PATH));
socket.on('disconnect', (reason) => console.log('[socket] disconnected:', reason));
socket.on('connect_error', (err) => console.warn('[socket] connect_error:', err?.message || err));